module.exports = __webpack_public_path__ + "img/partners_3.e253dd58.png";